"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
const shared_types_1 = require("@merchx-v2/shared-types");
exports.settings = {
    productTypesSettings: {
        [shared_types_1.PRODUCT_TYPE.TSHIRT]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.CREW]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.HOODIE]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.MUG]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.EXTERNAL_PRODUCT]: [],
        [shared_types_1.PRODUCT_TYPE.FACE_MASK]: [],
        [shared_types_1.PRODUCT_TYPE.STICKER]: [],
        [shared_types_1.PRODUCT_TYPE.POSTER]: [shared_types_1.ATTRIBUTE_TYPE.SIZE],
        [shared_types_1.PRODUCT_TYPE.STAINLESS_STEEL_WATER_BOTTLE]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.EMBROIDERED_POLO_SHIRT]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.TOTEBAG]: [shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.EMBROIDERED_BASEBALL_HAT]: [shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.HAT]: [shared_types_1.ATTRIBUTE_TYPE.COLOR],
        [shared_types_1.PRODUCT_TYPE.SUBSCRIPTION]: [],
        [shared_types_1.PRODUCT_TYPE.TSHIRT_LEGACY]: [],
        [shared_types_1.PRODUCT_TYPE.LONG_SLEEVED_SHIRT]: [shared_types_1.ATTRIBUTE_TYPE.SIZE, shared_types_1.ATTRIBUTE_TYPE.COLOR]
    }
};
exports.default = exports.settings;
//# sourceMappingURL=settings.js.map